import React, { ForwardedRef, forwardRef, HTMLAttributes } from "react";

import { FAQ } from "../FAQ";
import { HbmlElements } from "./HbmlElements";
import { hbmlNodeFactory } from "./common/hbmlNodeFactory";

export const HbmlFAQNode = hbmlNodeFactory<
    typeof HbmlElements.FAQ,
    Record<string, unknown>,
    Omit<HTMLAttributes<HTMLDivElement>, "content">
>({
    type: HbmlElements.FAQ,
    Component: forwardRef(function ComponentInternal(
        { node: _node, children, ...props },
        ref: ForwardedRef<HTMLDivElement>
    ) {
        return (
            <FAQ ref={ref} {...props}>
                {children!}
            </FAQ>
        );
    }),
});
